import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import {
  fetchCertificatesRollup,
  selectCertificatesRollup,
  selectCertificatesRollupStatus,
} from 'src/v3/profile/profile.slice'

export function useCertificatesRollup() {
  let dispatch = useAppDispatch()

  let data = useAppSelector(selectCertificatesRollup)
  let status = useAppSelector(selectCertificatesRollupStatus)

  let isLoading = status === 'pending' || status === 'uninitialized'
  let isError = status === 'rejected'
  let isSuccess = status === 'fulfilled'

  useEffect(() => {
    if (status === 'uninitialized') {
      dispatch(fetchCertificatesRollup())
    }
  }, [status, dispatch])

  return {
    data,
    status,
    isLoading,
    isError,
    isSuccess,
    refetch: () => dispatch(fetchCertificatesRollup()),
  }
}
